export default "__VITE_ASSET__310eb127__"